import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SearchInput } from '@reveni-io/reveni-ui'

import { minSearchChars, searchDebounceMs } from './constants'
import * as Styles from './styles'

const TopicDrawerSearch = ({ onSearch, initialValue = '' }) => {
  const { t } = useTranslation()
  const [value, setValue] = useState(initialValue)

  const handleChange = next => {
    setValue(next)
    if (!next) onSearch('')
  }

  return (
    <Styles.Container>
      <SearchInput
        fullWidth
        placeholder={t('Buscar en estas notas...')}
        onSearch={onSearch}
        value={value}
        onChangeValue={handleChange}
        minCharsToTrigger={minSearchChars}
        searchTimeout={searchDebounceMs}
      />
    </Styles.Container>
  )
}

export default TopicDrawerSearch
